// extracted by mini-css-extract-plugin
export default {"mCard":"_C-z","image":"aD-z","imageNoBackground":"bD-z","imageHasCategory":"cD-z","fullWidth":"dD-z"};